import { z } from 'zod'

import { Pagination } from 'app/types/app/request'
import { Manager } from 'app/types/park/manager'

export const DeliveryMan = z.object({
    client: Manager.array(),
    id: z.number().positive(),
    first_name: z.string().min(1),
    last_name: z.string().min(1),
    serial_number: z.string().min(1),
    card_id: z.string().min(1),
})

export type DeliveryMan = z.infer<typeof DeliveryMan>

export const DeliveryManPayload = DeliveryMan.omit({
    id: true,
}).extend({
    client: Manager.shape.id.array().optional(),
})

export type DeliveryManPayload = z.infer<typeof DeliveryManPayload>

export const DeliveryMenRequest = Pagination.extend({
    results: DeliveryMan.array(),
})

export type DeliveryMenRequest = z.infer<typeof DeliveryMenRequest>
